import { useTranslation } from "react-i18next";
import DetailSection from "../DetailSection";
import ActionDescriptionInput from "components/action-inputs/description/ActionDescriptionInput";

/**
 *
 * @param {Object} props
 * @param {import("constants/actions").Task} props.task - The base name of the task of the action, used to construct the input name for Formik.
 * @param {boolean} props.isProposed - Indicates whether the value is for a proposed action, affecting the input name construction.
 * @param {boolean} props.isViewMode - Determines if the input should be rendered in view mode, which typically disables editing and may change the appearance.
 * @returns {JSX.Element} A DetailSection component containing an ActionDescriptionInput, configured based on the provided task, proposed status, and view mode.
 */
const ActionModalDescriptionSection = ({ task, isProposed, isViewMode, isNewVersion }) => {
  const { t } = useTranslation();

  return (
    <DetailSection title={t("ActionModal.Description.Title")} isNewVersion={isNewVersion}>
      <ActionDescriptionInput
        task={task}
        isProposed={isProposed}
        isViewMode={isViewMode}
      />
    </DetailSection>
  );
};

export default ActionModalDescriptionSection;
